<template>
  <sui-segment>
    <sui-grid verticalAlign="middle">
      <sui-grid-row>
        <sui-grid-column :width="8">
          <div style="float:left">
            <sui-button id="backButton" color="black" @click.prevent="back" icon="arrow left" basic size="medium" style=" margin: 0.4em 0.4em 0; " />
          </div>
          <div style="float:left">
            <h2 is="sui-header">
              Kontakt
              <sui-header-subheader>So erreichen Sie uns</sui-header-subheader>
            </h2>
          </div>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
    <br />
    <fieldset>
      LAN1 Hotspots GmbH<br><br>
      Gau&szlig;stra&szlig;e 158<br>
      D-22765 Hamburg<br>
      Tel.:<a href="tel:+49040317666666"> +49 (0)40 317 66 66 66</a><br>
      Fax.:<a href="tel:+49040317666633"> +49 (0)40 317 66 66 33</a><br>
      Mail: <a href="mail:hotline@lan1.de">hotline@lan1.de</a>
      <br>
      <br>
    </fieldset>

  </sui-segment>
</template>
<script>
  export default {
    data() {
      return {
        fromRoute: null,
        fallbackRoute: '/',
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { vm.fromRoute = from })
    },
    methods: {
      back() {
          if (this.fromRoute === null || !this.fromRoute.name) {
            this.$router.push(this.fallbackRoute)
          } else {
            this.$router.back()
          }
      },
    }
  };
</script>
